import { Component } from "@angular/core";
import { WorkRequestService } from "@app/services/work-request.service";
import { GlobalConstants } from "@app/utils/global-constants";


@Component({
    selector: 'app-work-request-base',
    template: `
      <p>
        base works!
      </p>
    `,
    styles: [
    ]
  })
/**
 * 
 * 
 */
export class WorkRequestBase { 

  screenMode: string;

  constructor(
    
    protected workRequestService: WorkRequestService,

) {}

    /**
     * Determine Screen mode. Useful for direct URL access and the screen mode hasn't been set in parent.
     * @param id 
     * @returns 
     */
    determineScreenMode(id: number) {

        const resultPromise = new Promise((resolve, reject) => {
            this.workRequestService.getWorkRequestAccess(id)
                .subscribe({
                    next: (response: string[]) => {
                        if (response.includes(GlobalConstants.REQUEST_FORM_MODE_ADMIN) ) {
                            this.screenMode = GlobalConstants.REQUEST_FORM_MODE_ADMIN;
                        } else if (response.includes(GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT) ) {
                            this.screenMode = GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT;                             
                        } else if (response.includes(GlobalConstants.REQUEST_FORM_MODE_PM) ) {
                            this.screenMode = GlobalConstants.REQUEST_FORM_MODE_PM;
                        } else if (response.includes(GlobalConstants.REQUEST_FORM_MODE_USER) ) {
                            this.screenMode = GlobalConstants.REQUEST_FORM_MODE_USER;
                       
                        } else if (response.includes(GlobalConstants.REQUEST_FORM_MODE_SPONSORED) ) {
                                this.screenMode = GlobalConstants.REQUEST_FORM_MODE_SPONSORED;
                        } else {
                            //Don't default this anyone can read any request.
                            //this.screenMode = GlobalConstants.REQUEST_FORM_MODE_READ_ONLY;
                            this.screenMode = "";
                        }
                        console.log("Setting screen mode: " + this.screenMode);
                        resolve(true);
                    }
                    , error: (err: any) => {
                        resolve(false);
                    }
                });
        });
        return resultPromise;
    }

}